import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { API_BASE_URL_SERVICE } from '../../../../../projects/kiene-core/src/lib/kiene-core.config';
import { KieneTableService } from '../../../components/kiene-table/kiene-table.service';
import { MessageService } from '../../../../../projects/kiene-core/src/lib/services/message-service/message.service';
import { Preisgruppe } from '../preisgruppen';

@Component({
    selector: 'kiene-add-preisgruppe',
    templateUrl: './add-preisgruppe.component.html',
    styleUrls: ['./add-preisgruppe.component.scss'],
})
export class AddPreisgruppeComponent implements OnInit {
    preisgruppe: Preisgruppe;

    constructor(
        public dialogRef: MatDialogRef<AddPreisgruppeComponent>,
        public api: KieneTableService,
        @Inject(API_BASE_URL_SERVICE) private apiBaseUrl: string,
        public messageService: MessageService,
        @Inject(MAT_DIALOG_DATA) public data: any,
    ) {
        if (data.preisgruppe !== null && data.preisgruppe !== undefined) {
            this.preisgruppe = data.preisgruppe;
        } else {
            this.preisgruppe = new Preisgruppe();
        }
    }

    ngOnInit() {}

    cancel() {
        this.dialogRef.close();
    }

    save() {
        console.debug(JSON.stringify(this.preisgruppe));
        this.api.updateEntity(this.apiBaseUrl + 'preisgruppe/update.php', this.preisgruppe).subscribe(
            () => {
                this.cancel();
            },
            error => {
                this.messageService.errorMessage('Preisgruppe konnte nicht gespeichert werden!', error);
            },
        );
    }
}
